'use strict';

// These values should always match the variables set in _variables.scss and the contentImageBreakpoints site pref
module.exports.BreakpointSizes = {
    'sm': 544,
    'md': 769,
    'lg': 1024,
    'xl': 1440
};

module.exports.TransitionSpeed = 200;

module.exports.ComponentAnimationDelay = 0;

module.exports.Spacer = 16;

module.exports.placeholderImagePaths = {
    'thumbnail': '/images/gray.png',
    'imageMissing': '/images/placeholder.png'
}

module.exports.defaultMapMarker = {
    'color': 'white',
    'backgroundImage': '/images/icons/map-marker-default.svg'
}

module.exports.defaultStoreType = {
    'id': 0,
    'displayValue': 'Retail',
    'value': 'retail'
}

// These are used in cartridge/client/default/js/components/search.js
module.exports.UP_KEY = 38;
module.exports.DOWN_KEY = 40;
module.exports.DIRECTION_DOWN = 1;
module.exports.DIRECTION_UP = -1;

module.exports.States = {
    AU: [
        { id: 'ACT', htmlValue: 'ACT', label: 'Australian Capital Territory' },
        { id: 'NSW', htmlValue: 'NSW', label: 'New South Wales' },
        { id: 'NT', htmlValue: 'NT', label: 'Northern Territory' },
        { id: 'QLD', htmlValue: 'QLD', label: 'Queensland' },
        { id: 'SA', htmlValue: 'SA', label: 'South Australia' },
        { id: 'TAS', htmlValue: 'TAS', label: 'Tasmania' },
        { id: 'VIC', htmlValue: 'VIC', label: 'Victoria' },
        { id: 'WA', htmlValue: 'WA', label: 'Western Australia' },

    ],
    CA: [
        { id: 'AB', htmlValue: 'AB', label: 'Alberta' },
        { id: 'BC', htmlValue: 'BC', label: 'British Columbia'},
        { id: 'MB', htmlValue: 'MB', label: 'Manitoba'},
        { id: 'NB', htmlValue: 'NB', label: 'New Brunswick' },
        { id: 'NL', htmlValue: 'NL', label: 'Newfoundland and Labrador' },
        { id: 'NT', htmlValue: 'NT', label: 'Northwest Territories' },
        { id: 'NS', htmlValue: 'NS', label: 'Nova Scotia' },
        { id: 'NU', htmlValue: 'NU', label: 'Nunavut' },
        { id: 'ON', htmlValue: 'ON', label: 'Ontario' },
        { id: 'PE', htmlValue: 'PE', label: 'Prince Edward Island' },
        { id: 'QC', htmlValue: 'QC', label: 'Quebec' },
        { id: 'SK', htmlValue: 'SK', label: 'Saskatchewan' },
        { id: 'YT', htmlValue: 'YT', label: 'Yukon Territory' },
    ],
    US: [
        { id: 'AL', htmlValue: 'AL', label: 'Alabama' },
        { id: 'AK', htmlValue: 'AK', label: 'Alaska' },
        { id: 'AS', htmlValue: 'AS', label: 'American Samoa' },
        { id: 'AZ', htmlValue: 'AZ', label: 'Arizona' },
        { id: 'AR', htmlValue: 'AR', label: 'Arkansas' },
        { id: 'CA', htmlValue: 'CA', label: 'California' },
        { id: 'CO', htmlValue: 'CO', label: 'Colorado' },
        { id: 'CT', htmlValue: 'CT', label: 'Connecticut' },
        { id: 'DE', htmlValue: 'DE', label: 'Delaware' },
        { id: 'DC', htmlValue: 'DC', label: 'District of Columbia' },
        { id: 'FL', htmlValue: 'FL', label: 'Florida' },
        { id: 'GA', htmlValue: 'GA', label: 'Georgia' },
        { id: 'GU', htmlValue: 'GU', label: 'Guam' },
        { id: 'HI', htmlValue: 'HI', label: 'Hawaii' },
        { id: 'ID', htmlValue: 'ID', label: 'Idaho' },
        { id: 'IL', htmlValue: 'IL', label: 'Illinois' },
        { id: 'IN', htmlValue: 'IN', label: 'Indiana' },
        { id: 'IA', htmlValue: 'IA', label: 'Iowa' },
        { id: 'KS', htmlValue: 'KS', label: 'Kansas' },
        { id: 'KY', htmlValue: 'KY', label: 'Kentucky' },
        { id: 'LA', htmlValue: 'LA', label: 'Louisiana' },
        { id: 'ME', htmlValue: 'ME', label: 'Maine' },
        { id: 'MD', htmlValue: 'MD', label: 'Maryland' },
        { id: 'MA', htmlValue: 'MA', label: 'Massachusetts' },
        { id: 'MI', htmlValue: 'MI', label: 'Michigan' },
        { id: 'MN', htmlValue: 'MN', label: 'Minnesota' },
        { id: 'MS', htmlValue: 'MS', label: 'Mississippi' },
        { id: 'MO', htmlValue: 'MO', label: 'Missouri' },
        { id: 'MT', htmlValue: 'MT', label: 'Montana' },
        { id: 'NE', htmlValue: 'NE', label: 'Nebraska' },
        { id: 'NV', htmlValue: 'NV', label: 'Nevada' },
        { id: 'NH', htmlValue: 'NH', label: 'New Hampshire' },
        { id: 'NJ', htmlValue: 'NJ', label: 'New Jersey' },
        { id: 'NM', htmlValue: 'NM', label: 'New Mexico' },
        { id: 'NY', htmlValue: 'NY', label: 'New York' },
        { id: 'NC', htmlValue: 'NC', label: 'North Carolina' },
        { id: 'ND', htmlValue: 'ND', label: 'North Dakota' },
        { id: 'OH', htmlValue: 'OH', label: 'Ohio' },
        { id: 'OK', htmlValue: 'OK', label: 'Oklahoma' },
        { id: 'OR', htmlValue: 'OR', label: 'Oregon' },
        { id: 'PA', htmlValue: 'PA', label: 'Pennsylvania' },
        { id: 'PR', htmlValue: 'PR', label: 'Puerto Rico' },
        { id: 'RI', htmlValue: 'RI', label: 'Rhode Island' },
        { id: 'SC', htmlValue: 'SC', label: 'South Carolina' },
        { id: 'SD', htmlValue: 'SD', label: 'South Dakota' },
        { id: 'TN', htmlValue: 'TN', label: 'Tennessee' },
        { id: 'TX', htmlValue: 'TX', label: 'Texas' },
        { id: 'UT', htmlValue: 'UT', label: 'Utah' },
        { id: 'VT', htmlValue: 'VT', label: 'Vermont' },
        { id: 'VI', htmlValue: 'VI', label: 'Virgin Islands' },
        { id: 'VA', htmlValue: 'VA', label: 'Virginia' },
        { id: 'WA', htmlValue: 'WA', label: 'Washington' },
        { id: 'WV', htmlValue: 'WV', label: 'West Virginia' },
        { id: 'WI', htmlValue: 'WI', label: 'Wisconsin' },
        { id: 'WY', htmlValue: 'WY', label: 'Wyoming' },
        // APO/FPO
        { id: 'AE', htmlValue: 'AE', label: 'Armed Forces Africa' },
        { id: 'AA', htmlValue: 'AA', label: 'Armed Forces America (exc. Canada)' },
        { id: 'AE', htmlValue: 'AE', label: 'Armed Forces Canada' },
        { id: 'AE', htmlValue: 'AE', label: 'Armed Forces Europe' },
        { id: 'AE', htmlValue: 'AE', label: 'Armed Forces Middle East' },
        { id: 'AP', htmlValue: 'AP', label: 'Armed Forces Pacific' },
        // other
        { id: 'OTHER', htmlValue: 'OTHER', label: 'Non-US/Other' }
    ]
}
